import { Component, EventEmitter, Output, input } from '@angular/core';
import { Employee } from '@coin/shared/core/util-models';
import { ActionDef } from '@ngxs/store';
import { OrganisationService } from '../../models/organisation-service.model';

@Component({
  selector: 'customer-org-tree-overview',
  templateUrl: './org-tree-overview.component.html',
  styleUrls: ['./org-tree-overview.component.scss'],
  standalone: false
})
export class OrgTreeOverviewComponent {
  readonly rootEmployee = input<Employee>(undefined);
  readonly selectedEmployeeId = input<string>(undefined);
  readonly service = input<OrganisationService>(undefined);
  readonly seasonId = input<string>(undefined);
  readonly customOpenEmployeeInViewAction = input<ActionDef>(undefined);
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<void>();

  public onClose(): void {
    this.close.emit();
  }
}
